module.exports = __webpack_public_path__ + "images/emoji/passport_control.365a07904edb15e3abb8.png";